
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("h7CNN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::095fafc74fcbafa5e8b41c493c2b6af3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7713066954c39cb$var$_react = $c7713066954c39cb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c7713066954c39cb$var$_baseNew = $c7713066954c39cb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c7713066954c39cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Target".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/target
 * Usage guidance:
 * Single purpose - Reserved for targets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7713066954c39cb$var$TargetIcon = (props)=>/*#__PURE__*/ $c7713066954c39cb$var$_react.default.createElement($c7713066954c39cb$var$_baseNew.default, Object.assign({
        name: "TargetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25H4v1.5H1.543a6.5 6.5 0 0 0 5.707 5.707V12h1.5v2.457a6.5 6.5 0 0 0 5.707-5.707H12v-1.5h2.457A6.5 6.5 0 0 0 8.75 1.543V4h-1.5V1.543A6.5 6.5 0 0 0 1.543 7.25M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$c7713066954c39cb$var$TargetIcon.displayName = 'TargetIcon';
var $c7713066954c39cb$var$_default = module.exports.default = $c7713066954c39cb$var$TargetIcon;

});


//# sourceMappingURL=target.2a9413ec.js.map
